export const Tree = 'tree'

export const Blob = 'blob'
